module.exports = __webpack_public_path__ + "static/Solution_Img1-e6ede885d52b620499d018ddc60d2ae3.png";